// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Ak","zenCrossSiteLabel":"Bk","vrsnlCrossSiteLabel":"Ck"};